<nav #header class="fixed-top" style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerHeader" style="background-color: #132e59;">
        <div style="width: 300px;">
            <a href="{{this.companyParamsService.getWebSite()}}" target="_blank"><img
                    src="assets/images/logos-header/abc.svg" class="" alt=""
                    style="max-width: 320px; height: auto;" decoding="async"></a>
        </div>
        <div class="kontakt">
            <ul class="navbar-nav">
                <li class="nav-item menuItem">
                    <a href="https://antarcticbookingcenter.com/">Home</a>
                </li>
                <li class="nav-item menuItem">
                    <a href="https://antarcticbookingcenter.com/antarctica/" target="_blank">Antarctica</a>
                </li>
                <li class="nav-item menuItem">
                    <a href="https://antarcticbookingcenter.com/tour-packages/">Tour Packages</a>
                </li>
                <li class="nav-item menuItem">
                    <a href="https://antarcticbookingcenter.com/cruises/" target="_blank">Cruises</a>
                </li>
                <li class="nav-item menuItem">
                    <a href="https://antarcticbookingcenter.com/travel-guide/">Travel Guide</a>
                </li>
                <li class="nav-item menuItem">
                    <a href="https://antarcticbookingcenter.com/about/" target="_blank">About Us</a>
                </li>
                <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
                    <app-heart-header></app-heart-header>
                </li>
            </ul>
        </div>
        <div class="rightButton">
            <a (click)="goHome()">
                <span style="display: flex; align-items: center;">
                    <span style="padding-right: 10px;">Cruise Availability</span>
                    <i class="fa fa-telegram" style="border-radius: 100%;font-size: 50px;background-color: black;"></i>
                </span>
            </a>
        </div>
        <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
    </div>
    <ul class="navbar-nav verticalMenu" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem">
            <a href="https://antarcticbookingcenter.com/">Home</a>
        </li>
        <li class="nav-item menuItem">
            <a href="https://antarcticbookingcenter.com/antarctica/" target="_blank">Antarctica</a>
        </li>
        <li class="nav-item menuItem">
            <a href="https://antarcticbookingcenter.com/tour-packages/">Tour Packages</a>
        </li>
        <li class="nav-item menuItem">
            <a href="https://antarcticbookingcenter.com/cruises/" target="_blank">Cruises</a>
        </li>
        <li class="nav-item menuItem">
            <a href="https://antarcticbookingcenter.com/travel-guide/">Travel Guide</a>
        </li>
        <li class="nav-item menuItem">
            <a href="https://antarcticbookingcenter.com/about/" target="_blank">About Us</a>
        </li>
        <li>
            <div class="rightButtonResponsive">
                <span style="display: flex; align-items: center; justify-content: space-between;">
                    <span style="padding-right: 10px;">Cruise<br />Availability</span>
                    <i class="fa fa-telegram" style="border-radius: 100%;font-size: 30px;background-color: black;"></i>
                </span>
            </div>
        </li>
        <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
            <app-heart-header></app-heart-header>
        </li>
    </ul>
</nav>